import React, {Component} from 'react';
import {
    Container,
    Row,
    Button as ReactStrapButton,
    Col,
    FormGroup,
    Label,
    Media,
    Input,
    FormText, FormFeedback, CustomInput,
    Table, tbody, th, thead, tr
} from 'reactstrap';
import omit from 'lodash/omit';

import Button from '../../../shared/components/Button';
import Form from '../../../shared/components/Form';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';
import DateInput from "react-datepicker";
import moment from "moment";
import 'react-quill/dist/quill.snow.css';
import {DEFAULT_TIMEZONE} from "../../../config";
import {generateGUID} from "../../../shared/utils";

const dataVendors = {
    survey: [{
            key: "inbrain",
            name: "InBrain"
        },{
            key: "pollfish",
            name: "Pollfish"
        },{
            key: "tap",
            name: "Tap Research"
        },{
            key: "theorem",
            name: "Theorem Reach"
        },{
            key: "peanut",
            name: "Peanut Labs"
        }
    ],
    offer: [{
        key: "tapjoy",
        name: "Tap Joy"
    }, {
        key: "ironsource",
        name: "IronSource"
    }],
    // ad: [{
    //     key: "tile1",
    //     name: "Tile 1"
    // },{
    //     key: "tile2",
    //     name: "Tile 2"
    // },{
    //     key: "tile3",
    //     name: "Tile 3"
    // }]
};

const images = {
    offer: {
        tapjoy: [
            {name: 'Tapjoy Default', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Tapjoy-0X.jpg'},
            {name: 'Tapjoy 2x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Tapjoy-2X.jpg'},
            {name: 'Tapjoy 3x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Tapjoy-3X.jpg'}
            ],
        ironsource: [
            {name: 'Ironsource Default', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Ironsource-0X.jpg'},
            {name: 'Ironsource 2x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Ironsource-2X.jpg'},
            {name: 'Ironsource 3x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Ironsource-3X.jpg'}
            ]
    },
    survey: {
        inbrain: [
            {name: 'inBrain Default',   imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Inbrain-0X.jpg'},
            {name: 'inBrain 2x',        imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Inbrain-2X.jpg'},
            {name: 'inBrain 3x',        imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Inbrain-3X.jpg'}
        ],
        pollfish: [
            {name: 'Pollfish Default', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Pollfish-0X.jpg'},
            {name: 'Pollfish 2x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Pollfish-2X.jpg'},
            {name: 'Pollfish 3x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Pollfish-3X.jpg'}
        ],
        tap: [
            {name: 'Tap Research Default', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Tap-0X.jpg'},
            {name: 'Tap Research 2x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Tap-2X.jpg'},
            {name: 'Tap Research 3x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Tap-3X.jpg'}
        ],
        theorem: [
            {name: 'Theorem Reach Default', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Theorem-0X.jpg'},
            {name: 'Theorem Reach 2x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Theorem-2X.jpg'},
            {name: 'Theorem Reach 3x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/Theorem-3X.jpg'}
        ],
        peanut: [
            {name: 'Peanut Labs Default', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/PeanutLabs-0X.jpg'},
            {name: 'Peanut Labs 2x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/PeanutLabs-2X.jpg'},
            {name: 'Peanut Labs 3x', imageUrl: 'https://storage.googleapis.com/adjoy-app-assets/static/reward-promos/PeanutLabs-3X.jpg'}
        ],
    }
}

class EditRewardPromo extends Component {
    constructor(props) {
        super(props);
        this.splitRef = React.createRef();
        this.state = {
            domain: 'survey',
            vendors: {},
            isUpdating: false,
            isActivating: false,
            isLoading:false,
            error: null,
            validateForm: false,
            isCreate: false
        }
    }

    componentWillMount() {
        const {promo, defaultValues} = this.props
        if (promo) {
            this.setDefaultValuesForVendors(promo, defaultValues)
            this.setState({...promo,
                startDate: promo.startDate ? moment(promo.startDate).tz(DEFAULT_TIMEZONE) : moment().tz(DEFAULT_TIMEZONE).startOf('day'),
                endDate: promo.endDate ? moment(promo.endDate).tz(DEFAULT_TIMEZONE) : moment().tz(DEFAULT_TIMEZONE).startOf('day'),
                validateForm: true});
        } else {
            this.setState({
                isCreate: true,
                name: '',
                startDate: moment().tz(DEFAULT_TIMEZONE).startOf('day'),
                endDate:  moment().tz(DEFAULT_TIMEZONE).startOf('day').add(7, "day"),
                status: 'DRAFT',
                vendors: {}
            });
        }
    }

    componentWillUpdate(newProps, newState) {
        if (!newProps.isCreate && newProps.promo && !this.props.promo){
            const {promo, defaultValues} = newProps
            this.setDefaultValuesForVendors(promo, defaultValues)
            this.setState({...promo,
                startDate: promo.startDate ? moment(promo.startDate).tz(DEFAULT_TIMEZONE) : moment().tz(DEFAULT_TIMEZONE).startOf('day'),
                endDate: promo.endDate ? moment(promo.endDate).tz(DEFAULT_TIMEZONE) : moment().tz(DEFAULT_TIMEZONE).startOf('day'),
                validateForm: true,
                isCreate: false
            });
        }
    }

    componentDidMount(){
        if (!this.props.isCreate && this.props.needsLoading) {
            this.setState({isLoading:true});
            Promise.all(this.props.loadRewardPromos(), this.props.loadPromoDefaults())
                .then(() => this.setState({isLoading:false}))
                .catch(() => this.setState({isLoading:false}));
        }
    }

    setDefaultValuesForVendors(promo, defaultValues){
        promo.vendors = Object.assign({}, ...Object.values(promo.vendors).map(v => ({[v.id]: v})))
        for (const [key, value] of Object.entries(promo.vendors)) {
            value.defaultValue = defaultValues[promo.domain] * 100
            value.split = value.split * 100
            value.isEditing = false
            const availableImages = this.getImages(promo.domain, value.vendor)
            value.isCustomImage = availableImages.map(i => i.imageUrl).indexOf(value.imageUrl) === -1
        }
    }

    getImages(domain, vendor) {
        if (!domain || !vendor){
            return [{name: 'Not Selected', imageUrl: ''}]
        }
        return images[domain][vendor]
    }
    handleUseCustomImageChange(e, itemId){
        let vendors = this.state.vendors;
        vendors[itemId].isCustomImage = e.target.checked
        if (e.target.checked) {
            vendors[itemId].imageUrl = ''
        } else {
            this.setImageIfNeeded(vendors, itemId)
        }
        this.setState({ vendors: vendors })
    }

    handleImageUrlChange(e, itemId, image){
        let vendors = this.state.vendors;
        if (vendors[itemId].isCustomImage) {
            vendors[itemId].imageUrl = image.large
        } else {
            vendors[itemId].imageUrl = e.target.value
        }
        this.setState({ vendors: vendors })
    }

    setImageIfNeeded(vendors, itemId){
        const availableImages = this.getImages(this.state.domain, vendors[itemId].vendor)
        if (!vendors[itemId].isCustomImage && availableImages.map(i => i.imageUrl).indexOf(vendors[itemId].imageUrl) === -1){
            vendors[itemId].imageUrl = availableImages[0].imageUrl
        }
    }

    getAvailableVendors(domain, itemId){
        const vendors = Object.values(this.state.vendors);
        const vendorsAlreadyAdded = vendors.filter(s=> s.id !== itemId).map(t=>t.vendor)
        return dataVendors[this.state.domain].filter(i=>vendorsAlreadyAdded.indexOf(i.key) === -1)
    }


    onDomainChange(e){
        this.setState({domain: e.target.value, vendors: {}})
    }

    onVendorChange(itemId, e){
        let vendors = this.state.vendors;
        vendors[itemId].vendor = e.target.value
        this.setImageIfNeeded(vendors, itemId)
        this.setState({ vendors: vendors })
    }

    handleButtonSplitClick(e, itemId, multiplier){
        e.preventDefault()
        let vendors = this.state.vendors;
        let value = multiplier * vendors[itemId].defaultValue
        this.handleSplitChange(itemId, value)
    }

    handleSplitChange(itemId, value){
        let vendors = this.state.vendors;
        vendors[itemId].split = Number(value) || 0
        this.setState({ vendors: vendors })
    }


    updateEditingItem(itemId, value){
        let vendors = this.state.vendors;
        if(vendors[itemId].isNew){
            vendors[itemId].isNew = undefined
        }
        const editingItem = vendors[itemId]
        vendors[itemId].isEditing = value
        this.setState({ vendors: vendors, editingItem: value ? editingItem : null})
    }

    deleteItem(itemId, forceDelete){
        let {vendors, editingItem} = this.state;
        if (vendors[itemId].isNew || forceDelete) {
            this.setState({vendors: omit(this.state.vendors, itemId)})
        } else {
            vendors[itemId] = {...editingItem, isEditing: false}
            this.setState({ vendors: vendors, editingItem: null })
        }
    }

    isValidRewardPromo() {
        const {name, startDate, endDate, vendors} = this.state
        let values = Object.values(vendors)
        return name && startDate <= endDate && values.length > 0 && values.every(i => i.isEditing === false && i.imageUrl && i.split >= 1 && i.split <= 100)
    }

    handleSubmit(data) {
        console.debug("handleSubmit2")
        if (!this.isValidRewardPromo()) {
            this.setState({validateForm: true})
            console.log("Not Valid")
            return
        }

        const promo = this.props.promo || {}
        const {loadRewardPromos} = this.props
        const {isCreate, name, startDate, endDate, domain, vendors} = this.state
        const requestData = {
            ...(name !== promo.name && {name: name}),
            ...(domain !== promo.domain && {domain: domain}),
            ...((!promo.startDate || startDate.format('LLL') !== moment(promo.startDate).tz(DEFAULT_TIMEZONE).format('LLL')) && {startDate: moment.tz(startDate, DEFAULT_TIMEZONE).valueOf()}),
            ...((!promo.endDate || endDate.format('LLL') !== moment(promo.endDate).tz(DEFAULT_TIMEZONE).format('LLL')) && {endDate: moment.tz(endDate, DEFAULT_TIMEZONE).valueOf()}),
            vendors: Object.values(vendors).map(i=> ({vendor: i.vendor, imageUrl: i.imageUrl, split: i.split/100})),
            ...(isCreate && {status: 'DRAFT'})
        }
        // if (requestData.startDate) {
        //     console.log(moment(requestData.startDate).tz(DEFAULT_TIMEZONE).format('h:mm a, MMM D, YYYY z'))
        // }

        this.setState({isUpdating: true, error: null});
        if (isCreate) {
            this.props.createPromo({
                ...requestData
            })
                .then((res)=>res.instance.id)
                .then((id) => { return loadRewardPromos()
                    .then(() => {
                        this.setState({isCreate: false})
                        this.props.history.replace(`${this.getBackLink()}/${id}`);
                    } )})
                .then((res) => this.handleSuccess())
                .catch((err) => this.handleFailure(err));
        } else {
            this.props.updatePromo(this.props.promo.id, requestData)
                .then((res) => this.handleSuccess())
                .catch((err) => this.handleFailure(err));
        }
    }

    onActivateClick(){
        this.setState({isActivating: true, error: null});
        this.props.updatePromo(this.props.promo.id, {status: 'ACTIVE'})
            .then((res) => this.props.history.push(this.getBackLink(), {needUpdate: true}))
            // .then((res) => this.setState({status: 'active', isActivating: false}))
            .catch((err) => {
                this.handleFailure(err)
            });
    }

    handleSuccess() {
        this.setState({isUpdating: false, isActivating: false});
    }

    handleFailure(error) {
        console.log(error)
        let errorMessage = {}
        try {
            errorMessage = JSON.parse(error.message.replace(/'/g, '"'))
        } catch (e) {
            errorMessage = {message: error.message.replace(/'/g, '"')}
        }
        this.setState({error: errorMessage, isUpdating: false, isActivating: false});
    }

    onAddPromoItem(e){
        e.preventDefault()
        const id = generateGUID()
        const {defaultValues} = this.props
        const {vendors, domain} = this.state
        const availableVendors = this.getAvailableVendors(domain, id)
        const vendor = availableVendors && availableVendors[0] && availableVendors[0].key
        const defaultValue = (defaultValues[domain] || 0) * 100
        const images = this.getImages(domain, vendor)
        const imageUrl = images && images[0] && images[0].imageUrl
        vendors[id] = {isNew: true, id: id, vendor: vendor, split: defaultValue, defaultValue: defaultValue, imageUrl: imageUrl, isEditing: true}
        this.setState({vendors: vendors})
    }

    getSubmitText() {
        if (this.state.isUpdating && this.state.isCreate) {
            return 'Creating';
        } else if (this.state.isUpdating) {
            return 'Updating';
        } else if (this.state.isCreate) {
            return 'Create';
        } else {
            return 'Update';
        }
    }

    getBackLink() {
        return this.props.match.url.substring(0, this.props.match.url.lastIndexOf('/'));
    }

    render() {
        const {
            needsLoading,
            promo
        } = this.props;
        const {isCreate, name, domain, startDate, endDate, vendors, status} = this.state
        let values = Object.values(vendors)
        let item = values.filter(i => i.isEditing).shift();
        const {
            isUpdating,
            isActivating,
            validateForm,
            error
        } = this.state;

        if (this.state.isLoading) {
            return <div>Loading...</div>
        }

        if (!isCreate && !promo) {
            return <div>Reward promo failed to load</div>
        }

        return (
            <Container className="EditRewardPromo">
                <Row>
                    <Col xs='10'>
                        <h3>{isCreate ? 'Create Reward Promo' : `Edit ${promo.name}`}</h3>
                    </Col>
                </Row>
                {/*<Row>*/}
                {/*    <Col xs='10'>*/}
                {/*        Here comes default values from backend...*/}
                {/*    </Col>*/}
                {/*</Row>*/}
                <Row>
                    <Col>
                        <Form onSubmit={this.handleSubmit.bind(this)}>
                            <FormGroup row>
                                <Label for="name" sm={4}>Name</Label>
                                <Col sm={8}>
                                    <Input name="name"
                                           id="name"
                                           defaultValue={name}
                                           onChange={(e) => this.setState({ name: e.target.value })}
                                           invalid={(!name || name.length === 0) && validateForm}/>
                                    {(!name || name.length === 0) && <FormFeedback>Name is required</FormFeedback> }
                                    <FormText>Name of reward promo</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label for="domain" sm={4}>Domain</Label>
                                <Col sm={8}>
                                    <CustomInput type="select" name="domain"
                                                 id='domain'
                                                 defaultValue={domain}
                                                 invalid={(!domain || domain.length === 0) && validateForm}
                                                 onChange={(e) => this.onDomainChange(e)}>
                                        <option key='survey' value='survey'>Survey</option>
                                        <option key='offer' value='offer'>Offer</option>
                                    </CustomInput>
                                    <FormText>Domain to apply promo to</FormText>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='startDate'>Start Date</Label>
                                <Col sm={8}>
                                    <Row>
                                    <Col sm={4}>
                                    <DateInput id='startDate'
                                               className='form-control'
                                               minDate={moment().tz(DEFAULT_TIMEZONE).startOf("day")}
                                               selected={startDate}
                                               onChange={(d) => this.setState({startDate: moment.tz([d.year(), d.month(), d.date(), startDate.hour(), startDate.minute(),startDate.second()], DEFAULT_TIMEZONE)})}
                                    />
                                    </Col>
                                    <Col sm={4}>
                                        <Input
                                            type="time"
                                            name="startTime"
                                            id="startTime"
                                            value={startDate.format("HH:mm")}
                                            placeholder="start time"
                                            onChange={(e) => {
                                                console.log(e.target.value)
                                                this.setState({startDate: startDate.startOf("day").add(moment.duration(e.target.value))})
                                            }}
                                        />
                                    </Col>
                                    </Row>
                                    <FormFeedback>Incorrect Date</FormFeedback>
                                    <Row><Col sm={12}><FormText>When should promo start?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label sm={4} for='endDate'>Expiration Date</Label>
                                <Col sm={8}>
                                    <Row>
                                        <Col sm={4}>
                                            <DateInput id='endDate'
                                                       className='form-control'
                                                       disabled={!startDate}
                                                       minDate={startDate || moment().tz(DEFAULT_TIMEZONE).startOf("day")}
                                                       selected={endDate}
                                                       onChange={(d) => {
                                                           this.setState({endDate: moment.tz([d.year(), d.month(), d.date(), endDate.hour(), endDate.minute(),endDate.second()], DEFAULT_TIMEZONE)});
                                                       } }
                                            />
                                        </Col>
                                        <Col sm={4}>
                                            <Input
                                                type="time"
                                                name="endTime"
                                                id="endTime"
                                                value={endDate.format("HH:mm")}
                                                placeholder="end time"
                                                onChange={(e) => {
                                                    console.log(e.target.value)
                                                    this.setState({endDate: endDate.startOf("day").add(moment.duration(e.target.value))})
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                    {startDate >= endDate && validateForm &&
                                    <FormText color='danger'>Expiration date should be greater than start date</FormText>
                                    }
                                    <Row><Col sm={12}><FormText sm={12}>When should promo end?</FormText></Col></Row>
                                </Col>
                            </FormGroup>
                            { item ?
                                <Row>
                                    <Col sm={{size: 8,  offset: 4}}>
                                        <FormGroup row>
                                            <Label for="vendor" sm={4}>Vendor</Label>
                                            <Col sm={8}>
                                                <CustomInput type="select" name="vendor"
                                                             id='vendor'
                                                             defaultValue={item.vendor}
                                                             invalid={(!item.vendor || item.vendor.length === 0) && validateForm}
                                                             onChange={(e) => this.onVendorChange(item.id, e)}>
                                                    {this.getAvailableVendors(domain, item.id).map(vendor => <option key={vendor.key} value={vendor.key}>{vendor.name}</option>)}
                                                </CustomInput>
                                                <FormText>Which vendor to use?</FormText>
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label for="selectImageUrl" sm={4}>Image</Label>
                                            <Col sm={8}>
                                                <Row id="retailers">
                                                    <Col xs="auto">
                                                        <CustomInput type="switch" id='isCustomImage' name='isCustomImage' label='Use Custom Image' checked={item.isCustomImage} onChange={(e) => this.handleUseCustomImageChange(e, item.id)}/>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm={10}>
                                                        {item.isCustomImage ?
                                                        <DroppableFileInput
                                                            id='productImageUrl'
                                                            text='Product Image'
                                                            fileType='image'
                                                            onChange={(image) => this.handleImageUrlChange(undefined, item.id, image)}
                                                            cropperAspectRatio={4/3}
                                                            existingFileName={item.imageUrl ? item.imageUrl .split('/').pop(): ''}
                                                            existingFileURL={item.imageUrl }
                                                            warning={ item.imageUrl  || !validateForm ? '' : 'Product image is required'}
                                                        /> :
                                                            <CustomInput type="select" name="selectImageUrl"
                                                                         id='selectImageUrl'
                                                                         defaultValue={item.imageUrl}
                                                                         invalid={(!item.imageUrl || item.imageUrl.length === 0) && validateForm}
                                                                         onChange={(e) => this.handleImageUrlChange(e, item.id)}>
                                                                {this.getImages(domain, item.vendor).map((i) => (
                                                                    <option key={i.imageUrl} value={i.imageUrl}>{i.name}</option>
                                                                ))}
                                                            </CustomInput>
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col sm={6}>
                                                        <Media>
                                                            <Media left middle object src={item.imageUrl} style={{maxHeight:'256px', maxWidth:'256px'}} alt={''} />
                                                        </Media>
                                                    </Col>
                                                </Row>
                                                <FormFeedback>Image for reward promo is required</FormFeedback>
                                                <Row><Col sm={12}><FormText>Select image for reward promo</FormText></Col></Row>
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label for="split" sm={4}>Split</Label>
                                            <Col sm={8}>
                                                <Row>
                                                    <Col sm={6}>
                                                    <Input type="number"
                                                           name="split"
                                                           id="split"
                                                           ref={this.splitRef}
                                                           value={item.split}
                                                           invalid={(!item.split || Number(item.split) < 1 || Number(item.split) > 100) && validateForm}
                                                           onChange={(e) => this.handleSplitChange(item.id, e.target.value)}/>
                                                    </Col>
                                                    &nbsp;<ReactStrapButton color='link' onClick={(e)=>{this.handleButtonSplitClick(e, item.id, 1.5);}}>1.5x</ReactStrapButton>
                                                    &nbsp;<ReactStrapButton color='link' onClick={(e)=>{this.handleButtonSplitClick(e, item.id, 2);}}>2x</ReactStrapButton>
                                                    &nbsp;<ReactStrapButton color='link' onClick={(e)=>{this.handleButtonSplitClick(e, item.id, 3);}}>3x</ReactStrapButton>
                                                    <FormFeedback>{"Split should be between 1 and 100"}</FormFeedback>
                                                    <FormText>{`% to user; default is ${item.defaultValue}% to User / ${100 - item.defaultValue}% to Downtime Dollars`}</FormText>
                                                </Row>
                                            </Col>
                                        </FormGroup>
                                        <Button onClick={(e) => this.updateEditingItem(item.id, false)}>{item.isNew ? 'Add':'Edit'}</Button> &nbsp;
                                        <Button onClick={(e) => this.deleteItem(item.id, false)}>Discard</Button>
                                    </Col>
                                </Row>
                                :
                            <Row>
                                <Col sm={{size: 8,  offset: 4}}>
                                    <Table size="sm" borderless hover responsive>
                                    <thead>
                                    <tr>
                                        <th>Vendor</th>
                                        <th>Image</th>
                                        <th>Split</th>
                                        <th>Multiplier</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {values.length === 0
                                        ? <tr><td>No rewarded promos set...</td></tr>
                                        : values.map((item, index) => {
                                            return <tr key={item.id}>
                                                    <td>{item.vendor }</td>
                                                    <td>
                                                        <Media><Media left middle object src={item.imageUrl} style={{maxHeight:'32px', maxWidth:'32px'}} alt='Promo' />
                                                        </Media></td>
                                                    <td>{`${item.split}%`}</td>
                                                <td>{`${+(item.split/item.defaultValue).toFixed(2)}x`}</td>
                                                <td>

                                                    <Button
                                                        size='sm'
                                                        textColor='#666666'
                                                        borderColor='#cccccc'
                                                        backgroundColor='#fff'
                                                        onClick={(e) => this.updateEditingItem(item.id, true)}>
                                                        Edit
                                                    </Button> &nbsp;
                                                    <Button
                                                        size='sm'
                                                        textColor='#666666'
                                                        borderColor='#cccccc'
                                                        backgroundColor='#fff'
                                                        onClick={(e) => this.deleteItem(item.id, true)}>
                                                        Delete
                                                    </Button>
                                                </td>
                                                </tr>
                                        })}
                                    </tbody>
                                    </Table>
                            <Row>
                                <Button color="link" onClick={(e)=>this.onAddPromoItem(e)}>Add promo item</Button>
                            </Row>
                                </Col>
                            </Row>
                            }
                            <br/>
                            {error &&
                            <div>
                                { Object.entries(error).map(([key, value]) => <FormText color='danger' key={value}>{value}</FormText>)}
                                <br/>
                            </div>
                            }
                            <div>
                                <Button isSubmit disabled={isUpdating || !this.isValidRewardPromo()}>{this.getSubmitText()}</Button>
                                { status === 'DRAFT' &&
                                <Button className='ml-2' disabled={isUpdating || isActivating || !this.isValidRewardPromo()}
                                        onClick={() => this.onActivateClick()}>{this.state.isActivating ? 'Activating...' : 'Activate'}</Button>
                                }
                                <Button
                                    linkHref={this.getBackLink()}
                                    className='float-right'
                                    textColor='#666666'
                                    borderColor='#cccccc'
                                    backgroundColor='#ededed'> Cancel </Button>
                            </div>
                        </Form>
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default EditRewardPromo;



// WEBPACK FOOTER //
// ./src/routes/EditRewardPromo/components/EditRewardPromo.js